export default "__VITE_ASSET__DHiFaJR1__"